exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".infoTile{background-color:#f4f5f7;border-radius:2px;display:flex;flex-direction:column;font-size:14.864px;justify-content:center;max-width:180px;min-height:100px;min-width:120px;padding:15px 12px;text-align:center}@media (prefers-color-scheme: dark){:root:not([data-theme=light]):not([data-theme=dark]) .infoTile{background-color:#2a2c2f}}:root[data-theme=dark] .infoTile{background-color:#2a2c2f}.infoTile__value{color:#fa6422;display:block;font-size:24px;text-transform:uppercase}.infoTile--align-top{justify-content:flex-start;min-height:80px}@media (max-width: 959px){.infoTile{max-width:100px;min-width:105px;padding:15px 8px}}.infoTile .heading{font-size:20.576px !important}\n", ""]);

// exports
exports.locals = {
	"infoTile": "infoTile",
	"infoTile__value": "infoTile__value",
	"infoTile--align-top": "infoTile--align-top",
	"heading": "heading"
};